import styles from './StickyHeader.module.scss';

import cx from 'classnames';
import type { ReferencedEntry } from 'contentful';
import React from 'react';

import type { StickyHeaderAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { componentKey, getField, isEntry } from 'utils/EntryUtil';

import { Item } from './Item/Item';

interface IStickyHeaderProps extends React.AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<StickyHeaderAssembly>;
}

export const StickyHeader: React.FC<IStickyHeaderProps> = ({ entry, className, ...props }) => {
  const { browser } = useBreakpoints();
  const isMobile = browser.is.mobile;
  const isTablet = browser.is.tablet;

  if (!isEntry(entry)) return null;
  const items = getField(entry, 'items', []);

  const hasMultipleItems = items.length > 1;

  const useMinimalStyle = isMobile || (isTablet && hasMultipleItems);

  return (
    <section className={cx(styles.stickyHeaderWrapper, className)} {...props}>
      <div className={styles.stickyHeader}>
        {items.map((item, index) => (
          <React.Fragment key={componentKey(entry, index)}>
            {index === 1 && !isMobile && <hr className={styles.stickyHeaderRule} />}
            <Item itemEntry={item} showPriceAsSubtitle={hasMultipleItems} useMinimalStyle={useMinimalStyle} />
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};
